import React, { useState, useEffect } from "react";
import "./index.scss";
import MissionService from "../../../services/mission/mission.service";
import { showErrorToaster } from "../../../components/toaster/error";
import { useNavigate, useParams } from "react-router-dom";
import { showSuccessToaster } from "../../../components/toaster/success";

const missionService = new MissionService();

const JobForm = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // Récupère l'identifiant depuis l'URL pour l'édition
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    paye: "",
    salaire: "",
    typeContrat: "",
    level: "",
    typeWork: "",
  });
  const [error, setError] = useState("");

  // Charger les données de l'emploi en cas d'édition
  useEffect(() => {
    if (id) {
      // Si un identifiant est présent, nous sommes en mode "édition"
      const fetchMissionData = async () => {
        try {
          const response = await missionService.getMissionById(id);
          setFormData(response.data); // Remplit le formulaire avec les données existantes
        } catch (error) {
          showErrorToaster(
            error.response
              ? error.response.data.message
              : "Erreur lors du chargement des données."
          );
        }
      };
      fetchMissionData();
    }
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !formData.title ||
      !formData.description ||
      !formData.paye ||
      !formData.salaire ||
      !formData.typeContrat ||
      !formData.level ||
      !formData.typeWork
    ) {
      setError("Veuillez remplir tous les champs.");
      return;
    }

    try {
      if (id) {
        // Mode édition : Mettre à jour l'emploi existant
        await missionService.updateMission(id, formData);
        showSuccessToaster("Mise à jour réussie.");
      } else {
        // Mode création : Ajouter un nouvel emploi
        await missionService.addMission(formData);
        showSuccessToaster("Création réussie.");
      }
      navigate("/mission-liste");
    } catch (error) {
      showErrorToaster(
        error.response
          ? error.response.data.message
          : "Une erreur est survenue, veuillez réessayer."
      );
    }
  };

  return (
    <div className="job-form-container">
      <h1>{id ? "Modifier l'emploi" : "Créer un emploi"}</h1>
      <form onSubmit={handleSubmit}>
        {error && <div className="error-message">{error}</div>}
        <div className="form-group">
          <label>Titre:</label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label>Description:</label>
          <input
            type="text"
            name="description"
            value={formData.description}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label>Payé:</label>
          <input
            type="text"
            name="paye"
            value={formData.paye}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label>Salaire:</label>
          <input
            type="number"
            name="salaire"
            value={formData.salaire}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label>Type de contrat:</label>
          <input
            type="text"
            name="typeContrat"
            value={formData.typeContrat}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label>Niveau:</label>
          <input
            type="text"
            name="level"
            value={formData.level}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label>Type de travail:</label>
          <input
            type="text"
            name="typeWork"
            value={formData.typeWork}
            onChange={handleChange}
            required
          />
        </div>
        <button type="submit" className="submit-button">
          {id ? "Mettre à jour" : "Créer"}
        </button>
      </form>
    </div>
  );
};

export default JobForm;
